import { Button } from "@mui/material";
import { useContext, useState } from "react";
import CreateSimulationModal from "../../components/Modal/CreateSimulation/CreateSimulationModal";
import { Context } from "../../context/context";

export default function Simulator() {
  const { sidebar } = useContext(Context);
  const [open, setOpen] = useState(false);

  async function openNewSimulatorModal(e) {
    setOpen(true);
  }

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <Button
          size="medium"
          onClick={openNewSimulatorModal}
          style={{ width: "250px", marginTop: "20px" }}
          variant="contained"
          className="new-user"
        >
          Nova Simulação
        </Button>
      </main>
      {open && <CreateSimulationModal setOpen={setOpen} open={open} />}
    </>
  );
}
